<template>
	<div class="revenue-forecast-headings">
		<SuiDataTable
			:col-definition="colDefinition"
			:hide-header="loading"
			:loading="loading"
		>
			<SuiDataTableRow>
				<SuiDataTableCell class="revenue-forecast-headings__cell">
					<div>{{ $t('project_revenue_forecast_earned') }}</div>
					<SuiIcon
						v-tooltip="$t('project_revenue_forecast_earned_help')"
						class="revenue-forecast-headings__help"
						name="icon-info-16"
					/>
				</SuiDataTableCell>
			</SuiDataTableRow>
			<SuiDataTableRow>
				<SuiDataTableCell class="revenue-forecast-headings__cell">
					<span>{{ $t('project_revenue_forecast_recognized') }}</span>
					<SuiIcon
						v-tooltip="
							$t('project_revenue_forecast_recognized_help')
						"
						class="revenue-forecast-headings__help"
						name="icon-info-16"
					/>
				</SuiDataTableCell>
			</SuiDataTableRow>
			<SuiDataTableRow>
				<SuiDataTableCell class="revenue-forecast-headings__cell">
					<span>{{ $t('project_revenue_forecast_forcasted') }}</span>
					<SuiIcon
						v-tooltip="
							$t('project_revenue_forecast_forcasted_help')
						"
						class="revenue-forecast-headings__help"
						name="icon-info-16"
					/>
				</SuiDataTableCell>
			</SuiDataTableRow>
			<SuiDataTableRow class="revenue-forecast-headings__cell">
				<SuiDataTableCell>
					<span class="revenue-forecast-headings__highlighted">
						{{ $t('project_revenue_forecast_revenue') }}
					</span>
					<span
						v-if="currency"
						class="revenue-forecast-headings__currency"
					>
						({{ currency }})
					</span>
				</SuiDataTableCell>
			</SuiDataTableRow>
		</SuiDataTable>
	</div>
</template>

<script setup lang="ts">
import {
	SuiDataTable,
	SuiDataTableRow,
	SuiDataTableCell,
	SuiIcon,
} from '@developers/scoro-ui';
import { columWidth } from './constants';

export type ProjectRevenueForecastHeadingsProps = {
	loading: boolean;
	currency?: string;
};
defineProps<ProjectRevenueForecastHeadingsProps>();

const colDefinition = [{ id: 'caption', title: '', width: columWidth }];
</script>

<style scoped lang="scss">
.revenue-forecast-headings {
	:deep(.sui-data-table-header__col span) {
		display: inline-block;
	}

	:deep(.sui-data-table-col) {
		line-height: 4rem;
	}

	:deep(.sui-data-table-header__col) {
		height: 4.6rem;
	}

	&__cell {
		display: flex;
		align-items: center;
		padding-right: 2rem;
		text-wrap: nowrap;
		gap: 1rem;
	}

	&__highlighted {
		color: $neutral-80;
		font-weight: $scoro-fw-semi-bold;
	}

	&__currency {
		color: $neutral-70;
		margin-left: 0.625rem;
	}
}
</style>
